type Link = {
  link: string;
  tag: string;
};

class UiFlag extends HTMLElement {
  observedAttributes = ["data-flagcolor"];
  flagLinks: Link[] | undefined;

  constructor() {
    super();
    const flagLinks: Link[] | undefined = JSON.parse(document.querySelector("[data-flaglinks]")?.innerHTML ?? "");
    if (flagLinks?.length) this.flagLinks = flagLinks;
  }

  connectedCallback() {
    const tag = this.getAttribute("data-flagcolor");
    const link = this.flagLinks?.find((x) => x.tag.toLocaleLowerCase() === tag?.toLowerCase())?.link;
    if (link) {
      this.innerHTML = `<a href="${link}">${this.innerText}</a>`;
    }
  }
}

customElements.define("ui-flag", UiFlag);
